/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelJudgmentDto
 */
export interface CancelJudgmentDto {
    /**
     * Reason for cancelling the judgment; required when it was already accepted in P1
     * @type {string}
     * @memberof CancelJudgmentDto
     */
    reason?: string | null;
}

/**
 * Check if a given object implements the CancelJudgmentDto interface.
 */
export function instanceOfCancelJudgmentDto(value: object): value is CancelJudgmentDto {
    return true;
}

export function CancelJudgmentDtoFromJSON(json: any): CancelJudgmentDto {
    return CancelJudgmentDtoFromJSONTyped(json, false);
}

export function CancelJudgmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelJudgmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function CancelJudgmentDtoToJSON(value?: CancelJudgmentDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reason': value['reason'],
    };
}

